module.exports = __webpack_public_path__ + "931f8f4a086c8bd4b4f7539945f0e8b1.svg";